import { defineMessages, FormattedMessage } from 'react-intl'
import moment from 'moment'

import cardStyles from '../AdventureCardDsl.module.scss'
import cx from 'classnames'
import { Fragment } from 'react'

const adventureInclusions = {
  snorkelling: {
    icon: 'dsl-icons dsl-icons--snorkel-mask',
    message: <FormattedMessage defaultMessage='Snorkeling' />,
  },
  dive_trip: {
    icon: 'dsl-icons dsl-icons--flippers',
    message: <FormattedMessage defaultMessage='Fun dives' />,
  },
  social_event: {
    icon: 'dsl-icons dsl-icons--wine-light',
    message: <FormattedMessage defaultMessage='Social event' />,
  },
  conservation: {
    icon: 'dsl-icons dsl-icons--flippers',
    message: <FormattedMessage defaultMessage='Conservation' />,
  },
}

const inclusions = defineMessages({
  numberOfDives: {
    id: 'number_of_dives_card_inclusions',
    defaultMessage: '{numberOfDives, plural, one {# Dive} other {# Dives}}',
  },
  courseInclusionDays: {
    id: 'course_days_cards_inclusions',
    defaultMessage: '{numberOfDays, plural, one {#  Day} other {#  Days}}',
  },
  courseInclusionHours: {
    id: 'course_hours_card_inclusion',
    defaultMessage: '{numberOfHours, plural, one {# Hour} other {# Hours}}',
  },
  adventureCard: {
    id: 'adventure_card_info_type',
    defaultMessage: `{materialsType, select, 
      paper { Course includes paper manual, instruction + {numberOfDives, plural, one {# dive} other {# dives}}}
      other {Course includes eLearning, instruction + {numberOfDives, plural, one {# dive} other {# dives}}}}`,
  },
  eLearningCard: {
    id: 'elearning_card_info',
    defaultMessage: 'eLearning only',
  },
  paperCard: {
    id: 'paper_card_info',
    defaultMessage: 'Contact shop for pricing, dates and more information',
  },
  eLearningDuration: {
    id: 'elearning_card_duration',
    defaultMessage:
      '{durationFrom} - {durationTo, plural, one {# Hour} other {# Hours}}',
  },
})

const strings = {
  paper: inclusions.paperCard,
  elearning: inclusions.eLearningCard,
  adventure: inclusions.adventureCard,
}

const ActivityDuration = ({ item }) => {
  return (
    <div className={cardStyles.inclusion}>
      <i className='dsl-icons dsl-icons--timer' />
      {item.durationHours >= 24 ? (
        <FormattedMessage
          {...inclusions.courseInclusionDays}
          values={{
            numberOfDays: item.durationHours / 24,
          }}
        />
      ) : (
        <FormattedMessage
          {...inclusions.courseInclusionHours}
          values={{
            numberOfHours: item.durationHours,
          }}
        />
      )}
    </div>
  )
}

const ActivityDives = ({ item }) => {
  if(!item.numberOfDives) {
    return null
  }
  return (
    <div className={cx(cardStyles.inclusion, cardStyles.dives)}>
      <i className='dsl-icons dsl-icons--scuba-tank' />
      <FormattedMessage
        {...inclusions.numberOfDives}
        values={{
          numberOfDives: item.numberOfDives,
        }}
      />
    </div>
  )
}

const ElearningDuration = ({ item }) => {
  const { durationFrom, durationTo } = item

  return (
    <div className={cardStyles.inclusion}>
      <i className='dsl-icons dsl-icons--timer' />
      <FormattedMessage
        {...inclusions.eLearningDuration}
        values={{ durationFrom: Math.round(durationFrom), durationTo }}
      />
    </div>
  )
}

const CourseInclusions = ({ item, infoType }) => {
  const materialsType = item.isElearning ? 'elearning' : 'paper'
  return (
    <div className={cardStyles.inclusion}>
      <i className='dsl-icons dsl-icons--inventory' />
      <FormattedMessage
        {...strings[infoType]}
        values={{
          materialsType,
          numberOfDives: item.numberOfDives,
        }}
      />
    </div>
  )
}

const AdventureDuration = ({ item }) => {
  const { availableDate, durationHours } = item

  const dateFrom = moment(availableDate).format('DD MMM YYYY')
  const durationTime = moment(dateFrom)
    .add(durationHours, 'h')
    .format('DD MMM YYYY')

  return (
    <div className={cardStyles.inclusion}>
      <i className='dsl-icons dsl-icons--calendar' />
      <span>{dateFrom}</span>
      &nbsp; - &nbsp;
      <span>{durationTime}</span>
    </div>
  )
}

const AdventureInclusions = ({ item }) => {
  const { activityType } = item
  return (
    <div className={cardStyles.inclusions}>
      <div className={cardStyles.inclusion}>
        {activityType && (
          <Fragment>
            <i className={adventureInclusions[activityType]?.icon} />
            {adventureInclusions[activityType]?.message}
          </Fragment>
        )}
      </div>
      <ActivityDives item={item} />
      <AdventureDuration item={item} />
    </div>
  )
}

export {
  ActivityDuration,
  ActivityDives,
  CourseInclusions,
  AdventureInclusions,
  ElearningDuration,
  AdventureDuration,
}
